module.exports = __webpack_public_path__ + "vendor/fontawesome-webfont.woff2";


//////////////////
// WEBPACK FOOTER
// /Users/duat/Sites/acp/public_html/app/themes/dotone-child/node_modules/font-awesome/fonts/fontawesome-webfont.woff2
// module id = 33
// module chunks = 0